import SettingsIcon from '@mui/icons-material/Settings';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { useTheme } from '@/theme';

interface SettingsButtonProps {
  targetRoute: string;
  ariaLabel?: string;
  dataTestId?: string;
}

function SettingsButton({ targetRoute, dataTestId = 'settings-button', ariaLabel = 'Settings' }: SettingsButtonProps) {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleSettingsClick = () => {
    navigate(targetRoute);
  };

  return (
    <Button
      aria-label={ariaLabel}
      data-testid={dataTestId}
      variant='outlined'
      size='medium'
      onClick={handleSettingsClick}
      sx={{
        height: 36,
        padding: '4px',
        minWidth: '32px',
        color: theme.hhglobal.purpose.textWeak,
      }}
    >
      <SettingsIcon />
    </Button>
  );
}

export default SettingsButton;
